// extracted by mini-css-extract-plugin
export default {"choices":"styles_choices__CHu4d","validate-button":"styles_validate-button__YMYYa","local":"styles_local__uSsuD"};